import {html, type TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {ChapterData, chapterLinkEvent} from "./chapters";
import {trackingNavigationInteract} from "../../../tracking/trackingAttributes";
import {UnLitElement} from "../../../common/elements";

@customElement("eop-chapter-navigation-item")
export class EopChapterNavigationItem extends UnLitElement {

    public readonly id: string;

    @property({type: Boolean, reflect: true})
    public active: boolean;
    @state()
    private item: ChapterData;

    public render(): TemplateResult {
        return html`
            <a class="chapter-navigation-link"
               href=${this.item.href}
               @click=${this.handleClick}
               ${trackingNavigationInteract(this.item.name, this.item.href)}
            >
                <div class="chapter-name">${this.item.name}</div>
            </a>
        `;
    }

    private handleClick(event: Event): void {
        event.preventDefault();
        this.dispatchEvent(chapterLinkEvent(this.item));
    }
}